import { QSetStatus } from '@exam-management/graphql';
import { Tab, TabContext, TabList } from '@shared/components';

import { useQSetListSearchParams } from '../../hooks';

const tabList = [
  {
    value: QSetStatus.Draft,
    label: 'Draft',
  },
  {
    value: QSetStatus.InReview,
    label: 'In Review',
  },
  {
    value: QSetStatus.Reviewed,
    label: 'Reviewed',
  },
  {
    value: QSetStatus.Published,
    label: 'Published',
  },
  //TODO: Waiting to display Unpublished and Disabled for QSet
  // {
  //   value: QSetStatus.Unpublished,
  //   label: 'Unpublished',
  // },
  {
    value: QSetStatus.Disabled,
    label: 'Disabled',
  },
];

export default function QSetListNavigationTabs() {
  const [{ status }, { changeStatus }] = useQSetListSearchParams();

  const handleClick = (value: QSetStatus) => {
    changeStatus(value);
  };

  return (
    <TabContext value={status}>
      <TabList
        sx={(theme) => ({
          p: theme.spacing(4, 4, 0, 4),
        })}
      >
        {tabList.map((tab) => {
          return (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
              sx={{
                minWidth: 'unset',
              }}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
